import React, { useState } from "react";
import "./ReasonModal.css";

const ReasonModal = ({ isOpen, onClose, onSubmit }) => {
  const [reason, setReason] = useState("");

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!reason.trim()) {
      alert("Please enter a reason");
      return;
    }

    onSubmit(reason);
    setReason("");
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="reason-modal">
        {/* Header */}
        <div className="modal-header">
          <h2>Reason</h2>

          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          <label>Enter Reason</label>

          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter your reason..."
            rows={5}
          />
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>

          <button className="submit-btn" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReasonModal;
